import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { TokensAndDecodedToken } from "../interfaces/token-error";
import {
    BeamerAuthCodeKind,
    ModeratorLiveLessonKind, StudentEnetTokenKind,
    StudentLiveLessonKind,
    StudentUsernamePasswordKind,
    TeacherSerialsKind,
    TeacherUsernamePasswordKind,
} from "../interfaces/credentials";
import { PcpLiveSessionToken } from "../interfaces/live-lesson-token";


type AuthData =
    TeacherUsernamePasswordKind
    | TeacherSerialsKind
    | BeamerAuthCodeKind
    | StudentUsernamePasswordKind
    | StudentLiveLessonKind
    | ModeratorLiveLessonKind
    | StudentEnetTokenKind;


export const authServiceActions = createActionGroup({
    source: 'AuthService',
    events: {
        'User login requested': props<{ authData: AuthData }>(),
        'User login success': props<{ tokenData: TokensAndDecodedToken }>(),
        'User login failed': props<{ error: any }>(), // TODO: error type

        'tokenRefreshRequested': emptyProps(),
        'Token refresh success': props<{ tokenData: TokensAndDecodedToken }>(),
        'Token refresh failed': props<{ error: any }>(), // TODO: error type

        // Token restore (e.g. from localStorage) on page load
        'Token restore requested': props<{ token: string; refreshToken: string }>(),
        'Token restore success': props<{ tokenData: TokensAndDecodedToken }>(),
        'Token restore failed': props<{ error: any }>(), // TODO: error type

        // request to logOut the current user.
        // NOTE: this is just one way to log out the user - there is no guarantee this action is triggered.
        'Log out user': emptyProps(),

        // Dispatched when the user was logged out completely.
        // Always called internally by the auth service.
        'User has been logged out': emptyProps(),
    },
});

export const liveLessonAuthActions = createActionGroup({
    source: 'LiveLessonAuthService',
    events: {
        'User login requested': props<{ authData: AuthData }>(),
        'User login success': props<{ tokenData: TokensAndDecodedToken & { liveLesson: PcpLiveSessionToken } }>(),
        'User login failed': props<{ error: any }>(), // TODO: error type

        // Token restore (e.g. from localStorage) on page load
        'Token restore requested': props<{ token: string; refreshToken: string, liveLessonToken: string }>(),
        'Token restore success': props<{ tokenData: TokensAndDecodedToken & { liveLesson: PcpLiveSessionToken } }>(),
        'Token restore failed': props<{ error: any }>(), // TODO: error type
    },
});


